"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
// Use a React lazy component to dynamically load the appropriate captcha implementation
const CaptchaComponent = (props) => {
    const [CaptchaImpl, setCaptchaImpl] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        // Dynamically import the appropriate captcha implementation
        if (project_config_1.default.captchaComponentType === 'simple') {
            Promise.resolve().then(() => __importStar(require('./SimpleCaptcha'))).then((module) => {
                setCaptchaImpl(() => module.default);
            })
                .catch((err) => {
                console.error('Error loading captcha component:', err);
                setError('Failed to load captcha component');
            });
        }
        else if (project_config_1.default.captchaComponentType === 'capjs') {
            Promise.resolve().then(() => __importStar(require('./CapJsCaptcha'))).then((module) => {
                setCaptchaImpl(() => module.default);
            })
                .catch((err) => {
                console.error('Error loading captcha component:', err);
                setError('Failed to load captcha component');
            });
        }
        else {
            setError(`Unsupported captcha component type: ${project_config_1.default.captchaComponentType}`);
        }
    }, []);
    if (error) {
        return react_1.default.createElement("div", { className: "captcha-error" }, error);
    }
    if (!CaptchaImpl) {
        return react_1.default.createElement("div", { className: "captcha-loading" }, "Loading captcha...");
    }
    return react_1.default.createElement(CaptchaImpl, { onCaptchaValid: props.onCaptchaValid, reloadKey: props.reloadKey });
};
exports.default = CaptchaComponent;
//# sourceMappingURL=CaptchaComponent.js.map